<template>
  <div id="generate-document">
    <GlobalLoading v-if="isLoading" />
    <div class="document-container">
      <div ref="document" class="document-wrapper">
        <div class="pdf-logo-start">
          <div class="pdf-logo-komitmen">
            <img src="../../../assets/img/pdf/komitmen.png" height="45px" />
          </div>
        </div>
        <div class="doc-number">
          No. F-SIPM-01.04
        </div>
        <div class="doc-title-komitmen">
          PERNYATAAN KOMITMEN KESELAMATAN PERTAMBANGAN DAN LINGKUNGAN HIDUP
        </div>
        <div class="pdf-text mt20">Yang bertanda tangan dibawah ini :</div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Nama</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.nama }}</div>
        </div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Alamat</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.alamat }}</div>
        </div>
        <div class="pdf-form-wrapper mt20">
          <div class="pdf-form doc-indent">
            <span>Telepon / HP</span>
            <span>: </span>
          </div>
          <div class="pdf-form-content">{{ $route.query.phone }}</div>
        </div>
        <div class="mt20"></div>
        <div class="pdf-text mt20">Dengan ini menyatakan komitmen untuk:</div>
        <div class="mt20"></div>
        <div
          class="pdf-list doc-list-indent"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="index-col">{{ index + 1 }}.</div>
          <div class="desc-col">{{ item }}</div>
        </div>
        <!-- page break -->
        <div class="html2pdf__page-break" />
        <div class="pdf-logo-start">
          <div class="pdf-logo-komitmen">
            <img src="../../../assets/img/pdf/komitmen.png" height="45px" />
          </div>
        </div>
        <div class="doc-number">
          No. F-SIPM-01.04
        </div>
        <div
          class="pdf-list doc-list-indent"
          v-for="(item, index) in list2"
          :key="index"
        >
          <div class="index-col">{{ index + 11 }}.</div>
          <div class="desc-col">{{ item }}</div>
        </div>
        <div class="pdf-sign-komitmen doc-list-indent mt20">
          <div class="pdf-text mt20 text-center">
            Jakarta, {{ formatDate(Date.now()) }}
          </div>
          <div class="pdf-box-wrapper">
            <div class="pdf-box">
              <div class="pdf-small-text">Materai</div>
              <div class="pdf-small-text">Rp 10.000</div>
            </div>
          </div>
          <div class="pdf-text mt20 text-center">
            ({{ $get($route, 'query.nama') }})
          </div>
        </div>
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      list: [
        'Menjunjung tinggi nilai-nilai etika bisnis terhadap Kebijakan Golden Energy Mines (GEMS) dan atau [Kebijakan Unit Bisnis] serta senantiasa menekankan kepatuhan terhadap nilai / norma bisnis yang dimiliki GEMS dan [Unit Bisnis] untuk mencapai tingkat kinerja yang profesional dengan penuh tanggung jawab serta menciptakan lingkungan bisnis yang harmonis, adil, dan sehat.',
        'Bersedia mengikuti induksi Keselamatan Pertambangan dan Lingkungan Hidup Golden Energy Mines dan atau [Unit Bisnis].',
        'Mengikuti dan menjalankan seluruh pedoman dan persyaratan dari Sistem Manajemen Keselamatan Pertambangan dan Lingkungan Hidup GEMS dan atau [Unit Bisnis].',
        'Mematuhi peraturan perundang-undangan yang berlaku dalam bidang Keselamatan Pertambangan dan Lingkungan Hidup (KPLH) dan tidak boleh atau terlibat dalam kegiatan yang bisa bertentangan dengan peraturan perundang-undangan.',
        'Tidak melakukan kegiatan dan aktivitas yang dapat membahayakan keselamatan jiwa dan karyawan lain selama dalam area kerja GEMS dan atau [Unit Bisnis].',
        'Tidak membawa senjata api  dan senjata tajam selama memasuk area kerja GEMS dan atau [Unit Bisnis].',
        'Tidak membawa, mendistribusikan, menjual, dan mengkonsumsi alkohol dan narkotika selama berada di area kerja GEMS dan atau [Unit Bisnis].',
        'Tidak membuang limbah sembarangan dalam area kerja. Termasuk melakukan pembakaran terbuka dan menimbun sampah.',
        'Tidak memburu satwa liar  di dalam lokasi kerja termasuk memelihara binatang peliharaan.',
        'Melakukan tindakan yang bijak dan wajar untuk melindungi lingkungan sesuai dengan peraturan yang berlaku dan wajib mematuhi semua langkha-langkah perlindungan lingkungan sesuai yang dipersyaratkan oleh GEMS dan atau [Unit Bisnis].',
      ],
      list2: [
        'Melaporkan sesegera mungkin apabila menemukan kondisi bahaya atau yang berpotensi menimbulkan bahaya terhadap keselamatan dan lingkungan hidup kepada pengawas area atau pengawas yang ditunjuk sebagai pengawas pekerjaan yang saya lakukan.',
        'Menggunakan Alat Pelindung Diri yang disediakan apabila memasuki area kerja GEMS dan atau [Unit Bisnis].',
        'Bersedia menerima sanksi sesuai dengan pelanggaran terhadap peraturan KPLH GEMS dan atau [Unit Bisnis].',
        'Seluruh informasi dan dokumen yang diberikan adalah benar dan dapat dipertanggungjawabkan',
      ],
    }
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      html2pdf(this.$refs.document, {
        margin: 1,
        filename:
          'PERNYATAAN KOMITMEN KESELAMATAN PERTAMBANGAN DAN LINGKUNGAN HIDUP.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
